// @flow
import React from "react";

import { Translate } from "@quantum/i18n";

import {
  SelecaoCasasDecimais,
  SelecaoTipoConta,
  SelecaoVersaoConta,
  SelecaoPeriodo,
  SelecaoToleranciaDiasValorMercado,
  SelecaoToleranciaDF,
  SelecaoAjusteDias,
  SelecaoDeflacao,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";
import { useSelector } from "react-redux";

export const processarBalancoMercadoDeflator = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const modoSeries = isModoSeries(state);

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        periodicidade: edicaoMedida.periodicidade,
        ajusteDias: edicaoMedida.ajusteDias,
        tipoConta: edicaoMedida.tipoConta,
        versaoConta: edicaoMedida.versaoConta,
        toleranciaDF: edicaoMedida.toleranciaDF,
        toleranciaDiasValorMercado: edicaoMedida.toleranciaDiasValorMercado,
        deflator: edicaoMedida.deflator,
        valorBaseDeflator: edicaoMedida.valorBaseDeflator,
        valorBaseDeflatorOutro: edicaoMedida.valorBaseDeflatorOutro,
        dataBaseDeflator: edicaoMedida.dataBaseDeflator,
        dataBaseDeflatorDataEspecifica:
          edicaoMedida.dataBaseDeflatorDataEspecifica,
        dataBase: dataBase,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        periodicidade: edicaoMedida.periodicidade,
        ajusteDias: edicaoMedida.ajusteDias,
        tipoConta: edicaoMedida.tipoConta,
        versaoConta: edicaoMedida.versaoConta,
        toleranciaDF: edicaoMedida.toleranciaDF,
        toleranciaDiasValorMercado: edicaoMedida.toleranciaDiasValorMercado,
        deflator: edicaoMedida.deflator,
        valorBaseDeflator: edicaoMedida.valorBaseDeflator,
        valorBaseDeflatorOutro: edicaoMedida.valorBaseDeflatorOutro,
        dataBaseDeflator: edicaoMedida.dataBaseDeflator,
        dataBaseDeflatorDataEspecifica:
          edicaoMedida.dataBaseDeflatorDataEspecifica,
        dataBase: dataBase,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

export default function BalancoMercadoDeflator() {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida__box">
          <div className="ConfiguracaoMedida__box">
            <SelecaoToleranciaDiasValorMercado />
          </div>

          <div className="ConfiguracaoMedida__box">
            <SelecaoToleranciaDF />
          </div>
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />
        <div className="ConfiguracaoMedida">
          <h3 className="ConfiguracaoMedida__group-title">
            <Translate>configuracaoRelatorio.parametros</Translate>
          </h3>
          <div className="ConfiguracaoMedida__group--grey">
            <div className="ConfiguracaoMedida__box">
              <SelecaoTipoConta />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoVersaoConta />
            </div>
          </div>
        </div>
        <div className="ConfiguracaoMedida__vertical-divider" />
        <SelecaoDeflacao exibirLabelLegado={true} />
      </>
    );
  } else {
    return (
      <>
        <SelecaoPeriodo exibirPeriodicidade={false} />
        <div className="ConfiguracaoMedida__box">
          <SelecaoToleranciaDiasValorMercado />
          <SelecaoToleranciaDF />
          <SelecaoAjusteDias />
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />
        <div className="ConfiguracaoMedida">
          <h3 className="ConfiguracaoMedida__group-title">
            <Translate>configuracaoRelatorio.parametros</Translate>
          </h3>
          <div className="ConfiguracaoMedida__group--grey">
            <div className="ConfiguracaoMedida__box">
              <SelecaoTipoConta />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoVersaoConta />
            </div>
          </div>
        </div>
        <div className="ConfiguracaoMedida__vertical-divider" />
        <SelecaoDeflacao exibirLabelLegado={true} />
        <div className="ConfiguracaoMedida__vertical-divider" />
        <SelecaoCasasDecimais />
      </>
    );
  }
}
